<script lang="ts">
    export let theme: 'default' | 'white' = 'default';
    export let center = false;
</script>

<span class="linear-preloader theme-{theme || 'default'}" class:center>
    <span class="dot dot-1" />
    <span class="dot dot-2" />
    <span class="dot dot-3" />
    <span class="dot dot-4" />
    <span class="dot dot-5" />
    <span class="dot dot-6" />
    <span class="dot dot-7" />
    <span class="dot dot-8" />
</span>

<style lang="postcss">
    .linear-preloader {
        @apply inline-block relative;
        width: 126px;
        height: 15px;

        &.center {
            @apply block mx-auto;
        }

        .dot {
            @apply absolute top-0 bg-green;
            width: 15px;
            height: 15px;
            animation-name: linear-preloader;
            animation-duration: 1.05s;
            animation-iteration-count: infinite;
            animation-direction: normal;
            transform: scale(0.3);
            border-radius: 50%;
        }

        &.theme-white {
            .dot {
                @apply bg-white;
                animation-name: linear-preloader-white;
            }
        }

        .dot-1 {
            left: 0;
            animation-delay: 0s;
        }

        .dot-2 {
            left: 16px;
            animation-delay: 0.15s;
        }

        .dot-3 {
            left: 31px;
            animation-delay: 0.3s;
        }

        .dot-4 {
            left: 47px;
            animation-delay: 0.45s;
        }

        .dot-5 {
            left: 63px;
            animation-delay: 0.6s;
        }

        .dot-6 {
            left: 79px;
            animation-delay: 0.75s;
        }

        .dot-7 {
            left: 94px;
            animation-delay: 0.9s;
        }

        .dot-8 {
            left: 110px;
            animation-delay: 1.05s;
        }
    }

    @keyframes linear-preloader {
        0% {
            transform: scale(1);
            @apply bg-green;
        }

        100% {
            transform: scale(0.3);
            @apply bg-white;
        }
    }

    @keyframes linear-preloader-white {
        0% {
            transform: scale(1);
            @apply bg-white;
        }

        100% {
            transform: scale(0.3);
            @apply bg-gray;
        }
    }
</style>
